import React, { useEffect, useState } from 'react';
import axios from 'axios';
import JiraIntegrationPopupHeader from './jiraIntegrationPopupHeader';
import JiraIntegrationPopupAddInstances from './jiraIntegrationPopupAddInstances';
import JiraIntegrationPopupListInstances from './jiraIntegrationPopupListInstances';
import JiraIntegrationPopupBasic from './jiraIntegrationPopupBasic';
import JiraIntegrationPopupNoInstances from './jiraIntegrationPopupNoInstances';
import { reactLoader, removeReactLoader } from '../../../utils/common';
import { ThemeProvider } from '@workboard/wobo-ui';
import { useTranslation } from 'react-i18next';

// React version of _jira_auth.php
const JiraIntegrationPopup = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState({});
  const [addAnother, setAddAnother] = useState(false);
  const { t } = useTranslation()
  useEffect(() => {
    document.querySelector('body').classList.add('no-scroll');
    if (document.querySelector('.goalPopupNew')) {
      document.querySelector('.goalPopupNew').style['z-index'] = 1000;
    }

    reactLoader();

    const getAllInstances = () => axios.get(
      `${wbConfig.baseUrl}/integration/getAllInstances`, {
        params: {
          app: "jira"
        }
      }
    );

    const jiraOAuth = () => axios.get(`${wbConfig.baseUrl}/integration/jiraOAuth`);

    axios.all([getAllInstances(), jiraOAuth()])
      .then(axios.spread((instanceData, oAuthData) => {
        removeReactLoader();
        if (instanceData && instanceData.data && instanceData.data.data && 
          oAuthData && oAuthData.data && oAuthData.data.data) {

          if (oAuthData.data.data.isJiraOAuthEnabled) {
            const connectedInstances = instanceData.data.data;
            const allInstances = oAuthData.data.data.jiraInstances;
            const availableInstances = [];

            if (oAuthData.data.data.isJiraOAuth2) {
              availableInstances = allInstances;
            } else {
              allInstances.forEach(instance => {
                if (!connectedInstances.find(cInstance => cInstance.belong_to == instance.url)) {
                  availableInstances.push(instance);
                }
              })  
            }

            setData({
              ...oAuthData.data.data,
              jiraInstances: availableInstances
            });
          }
          else {
            setData(oAuthData.data.data);
          }
          
          setIsLoading(false);
        }
        else {
          props.closePopup(true);
          alert(t("Unable to process this request at this moment, please try later."));
        }
      }))
      .catch(e => {
        removeReactLoader();
        props.closePopup(true);
        alert(t("Unable to process this request at this moment, please try later."));
      })
    
    return () => document.querySelector('body').classList.remove('no-scroll');
  }, []);

  const modifyJiraInstances = (instances) => {
    // {url: https://abcd.atlassian.net, key: connect}
    const modifiedInstances = instances.map((instance, i) => {
      return { ...instance, name: instance.url, value: i };
    });
    return modifiedInstances;
  };

  if (isLoading) return null;

    return (
      <ThemeProvider>
        <div id="myModal" className="jira-modal-bg">
          <div id="jiraLoginIntg" className="jira-modal">
            <JiraIntegrationPopupHeader
              closePopup={props.closePopup}
            />
            {data.isJiraOAuthEnabled
              ? addAnother
                ? (
                  <JiraIntegrationPopupAddInstances
                    data={data}
                    closePopup={props.closePopup}
                    updateParentState={props.updateParentState}
                  />
                  ) // 5 steps
                : (
                  data.jiraInstances.length && (!data.isJiraOAuth2)
                    ? (
                      <JiraIntegrationPopupListInstances
                        instances={modifyJiraInstances(data.jiraInstances)}
                        orgName={data.orgName}
                        closePopup={props.closePopup}
                        updateParentState={props.updateParentState}
                        setAddAnother={setAddAnother}
                      />
                      )
                    : (
                      <JiraIntegrationPopupNoInstances
                        data={data}
                        closePopup={props.closePopup}
                        setAddAnother={setAddAnother}
                        updateParentState={props.updateParentState}
                      />
                      )
                  )
              : ((!data.isJiraOAuth2) &&
                <JiraIntegrationPopupBasic
                  closePopup={props.closePopup}
                  updateParentState={props.updateParentState}
                />
              )}
          </div>
        </div>
      </ThemeProvider>
    );
  
};

export default JiraIntegrationPopup;
